import {Component, Input, OnInit} from '@angular/core';
import {AssetResource} from '../../../../../class/lifeproject/asset-resource';

@Component({
  selector: 'app-resource-list',
  templateUrl: './resource-list.component.html',
  styleUrls: ['./resource-list.component.css']
})
export class ResourceListComponent implements OnInit {

  @Input()
  assetResources: AssetResource[];

  constructor() {
  }

  ngOnInit() {
  }

}
